import { t } from '@lingui/core/macro';
import { BookingLocationType, BookingRecordDetailsCustomer } from '@navio/nsdk';

/** Stationary (at-station) bookings — brand-agnostic; adapter is server-side. */
export const isStationaryBooking = (locationType: string) => locationType === BookingLocationType.STATIONARY;

/**
 * Names the booking by its first service, e.g. "Tire change + 2 more". Order lines carry the
 * customer-facing service names; service categories are internal and untranslated.
 */
export const getBookingServiceTitle = (booking: BookingRecordDetailsCustomer) => {
  const serviceNames = [
    ...new Set(booking.order.orderLines.filter((line) => !line.isDeliveryFee).map((line) => line.description))
  ];
  const [mainService] = serviceNames;
  if (!mainService) {
    return t`Booking`;
  }
  const extraCount = serviceNames.length - 1;
  return extraCount > 0 ? t`${mainService} + ${extraCount} more` : mainService;
};

/** A receipt exists only once something is paid, and is offered once nothing is left to pay. */
export const getCanDownloadBookingReceipt = (booking: BookingRecordDetailsCustomer) =>
  booking.order.receipts.length > 0 && booking.order.amountOutstanding.amount <= 0;
